// extracted by mini-css-extract-plugin
export default {"div":"Chooser_div__upRgJ","imgDiv":"Chooser_imgDiv__cMBzw","img":"Chooser_img__7-8qP","overlay":"Chooser_overlay__2qlXJ","thumbnail":"Chooser_thumbnail__Q8PIL"};